<template>
    <div v-if="style === 'card'"    class="relative flex flex-col min-h-full p-2 bg-white border shadow-md rounded-3xl shadow-black/5 ring-1 ring-black/5 show-card dark:border-gray-200 dark:border dark:bg-gray-800 border-clay-200">
        <a :href="` /${show.urlSlug}`" :alt="show.title" :title="show.title" class="guide-img-container">
            <img :src="show.logo" :alt="`${show.title} logo`" :title="`${show.title} logo`"
                class="object-cover mx-auto sm:w-full aspect-square rounded-2xl max-w-80 w-full">
        </a>
        <div class="flex flex-col flex-1 p-4">

            <div class="mt-2 font-medium text-base/7">
                <a :href="`/${show.urlSlug}`" :alt="show.title" :title="show.title" class="text-clay-950"><span
                        class="absolute inset-0"></span>
                    <h3 class="">{{ show.title }}</h3>
                </a>
            </div>
            <div class="">

                <div class="text-clay-950 text-sm/5">
                    <p>{{ show.category }}</p>
                </div>
            </div>
            <div class="flex-1 mt-2 text-gray-600 text-sm/6">{{ show.plotOverviewExcerpt }}</div>
            <div v-if="show.hasScript" class="relative min-w-full slider-hidden">
                <a class="z-10 block px-2 py-1 mt-4 text-xs font-medium text-center rounded-full text-clay-950 light:bg-clay-50 dark:bg-gray-600"
                    :href="`/${show.urlSlug}/script`" :alt="`Full text for ${show.title}`"
                    title="`Full text for ${show.title}`">
                    <span style="font-size: 0.85rem;" class="">
                        <i class="mr-1 far fa-file-alt"></i> Full Script
                    </span>
                </a>
            </div>
            
            <div v-if="show.opportunityCount" class="relative min-w-full slider-hidden" title="This guide has active opportunities">
                <div class="z-10 mt-4 text-xs leading-5 text-center text-electric-700">
                <div class="flex-none inline-block p-1 mr-1 rounded-full bg-emerald-500/20">
                    <div class="h-1.5 w-1.5 rounded-full bg-emerald-500"></div>
                </div>
                <a :href="`/${show.urlSlug}/opportunities`" :alt="`Opportunities for ${show.title}`"
                    :title="`Opportunities for ${show.title}`" class="border-b hover:border-none">
                    {{ show.opportunityCount }} active
                    <span v-if="show.opportunityCount === 1">opportunity</span>
                    <span v-else>opportunities</span>
                </a>
                </div>
            </div>
            <div class="z-10 flex items-center gap-3 mx-auto mt-6 slider-hidden">

                <fanning :id="show.id" :number-of-fans="show.fanCount" />
                <Bookmarking :id="show.id" />
            </div>
        </div>
    </div>

    <div v-else-if="style === 'stack'" class="flex items-start space-x-4 text-base sm:text-sm">
        <div class="flex-none mt-1">
            <a :href="`/${show.urlSlug}`" :alt="show.title" :title="show.title">
                <img class="object-cover w-8 rounded-lg shadow-lg" :src="show.logo" :alt="`${show.title} logo`"
                    :title="`${show.title} logo`">
            </a>
        </div>

        <div class="flex-grow">
            <a :href="`/${show.urlSlug}`" :alt="show.title" :title="show.title"
                class="block font-medium hover:underline">
                <h3 class="">{{show.title}}</h3>
            </a>
            <dl>
                <dt class="sr-only">Category</dt>
                <dd class="">
                    <span class="text-xs">{{show.category}}</span>
                </dd>
            </dl>
        </div>
    </div>
</template>

<script lang="ts" setup>
import {defineProps} from "vue";
import Bookmarking from "@/main/components/Bookmarking.vue";
import Fanning from "@/main/components/Fanning.vue";
import {ShowDto} from "@/dtos";

const props = defineProps<{
    show: ShowDto;
    style?: string;
}>();

const show: ShowDto = props.show;
const style: string = props.style ?? 'card'; // Provide default value using nullish coalescing

</script>
<style>

</style>